import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';
import {Route} from 'react-router-dom';

export default [
  <Route key="/business/showcase/scarves" element={<ShowocaseLayout />}>
    <Route path="business/showcase/scarves" element={<AsyncPage />} />
  </Route>,
];
